const EmptyState = () => {
  return <div className="empty">Data tidak ditemukan!</div>;
};

export default EmptyState;
